import { DASHBOARD_PAGE } from '@eag/sales-app-base/build/app/core/routes/paths';
import { MenuItem } from 'primereact/menuitem';
import { Sidebar } from 'primereact/sidebar';
import { classNames } from 'primereact/utils';
import { useTranslation } from 'react-i18next';
interface Props {
	menu: MenuItem[];
	visible: boolean;
	hide: () => void;
}

export const SidebarComponent = (props: Props) => {
	return (
		<Sidebar
			className="sidebar-style"
			visible={props.visible}
			showCloseIcon={false}
			onHide={props.hide}
			dismissable
			position="right"
			header={<SidebarHeader {...props} />}>
			<div className="sidebar-content">
				{props.menu.map((menuItem: MenuItem) => {
					return (
						<li key={menuItem.label}>
							<a
								key={menuItem.label}
								onClick={props.hide}
								href={menuItem.url}
								className={classNames('sidebar-item', menuItem.className)}>
								<span className={classNames(menuItem.url)}>{menuItem.label}</span>
							</a>
						</li>
					);
				})}
			</div>
			<div className="sidebar-footer" />
		</Sidebar>
	);
};

const SidebarHeader: React.FC<Props> = (props) => {
	const { t } = useTranslation();

	return (
		<div className="sidebar-header app-navigation">
			<div className="navigation-top">
				<div className="left" />
				<div className="right">
					<a className="logo-gruenstrom" href={DASHBOARD_PAGE}>
						<img src="/assets/img/brand/logo.png" alt={t('navigation.logo-gruenstrom.alt')} />
					</a>
				</div>
			</div>
			<div className="navigation-bottom">
				<div className="navigation-menu">
					<div className="navigation-menu-buttons-wrapper">
						<button className="button naked close" onClick={props.hide} />
					</div>
				</div>
			</div>
		</div>
	);
};
